import Table, { compareStrings } from 'apollo-react/components/Table';
import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL, OBJ_ROLE, SYS_ROLE } from '../common/Constants';
import Loading from '../common/Loading';
import './UserManagement.scss';
import Plus from 'apollo-react-icons/Plus';
import userManagementData from '../json/userManagementData.json';
import { getApi, getFuncroleFlg, setURL, redirectToLogin } from '../common/Utils';
import { Link } from 'apollo-react';
import { format } from 'date-fns';
import funcroleData from '../json/funcroleData.json';
import selectItemUserRoleList from '../json/selectItemUserRoleList.json';
import Search from 'apollo-react-icons/Search';
import { Button } from 'apollo-react';

/**							
 * ファイル管理							
 */
function UserManagement() {
	const location = useLocation();
	const [t, i18n] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		DELETE_CONFIRM_DIALOG: '3',
	};
	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [searchUserName, setSearchUserName] = useState('');
	const [searchOrg, setSearchOrg] = useState('');
	const [searchDept, setSearchDept] = useState('');
	const [searchMail, setSearchMail] = useState('');
	const [searchAuth, setSearchAuth] = useState('');

	// 検索結果を保持するための状態変数
	const [filteredUsers, setFilteredUsers] = useState([]);
	// 検索が実行されたかどうかを示すフラグ
	const [isSearched, setIsSearched] = useState(false);

	// ユーザー情報変更リンククリック権限
	const [addUserLinkAuthList, setAddUserLinkAuthList] = useState(false);
	// ユーザー追加ボタン権限						
	const [addUserBtnAuthFlg, setAddUserBtnAuthFlg] = useState(false);
	// 一覧の表示リスト権限						
	const [userManagementList, setUserManagementList] = useState([]);
	// 権限の選択リスト
	const [userRoleList, setUserRoleList] = useState([]);

	const UserIdCell = ({ row }) => {
		return (
			<Link disabled={!addUserLinkAuthList} onClick={() => handleLinkClick(row)} >
				{row.dspUsrCode}
			</Link>
		);
	};

	const UserNameCell = ({ row }) => {
		return (
			<Link disabled={!addUserLinkAuthList} onClick={() => handleLinkClick(row)} >
				{row.userName}
			</Link>
		);
	};

	// 各日付データをjavascript側で指定の書式(yyyy/mm/dd)へフォーマット変換						
	const ExpiryDateCell = ({ row }) => {
		const ret = row.expiryDate !== null ? format(new Date(row.expiryDate), 'yyyy/MM/dd') : '';
		return ret;
	};
	const RecIDateCell = ({ row }) => {
		const ret = row.recIdate !== null ? format(new Date(row.recIdate), 'yyyy/MM/dd') : '';
		return ret;
	};
	const RecDateCell = ({ row }) => {
		const ret = row.recDate !== null ? format(new Date(row.recDate), 'yyyy/MM/dd') : '';
		return ret;
	};
	// 最終ログイン日時　改善
	//const LastLoginCell = ({ row }) => {
	//	const ret = row.lastloginDate !== null ? format(new Date(row.lastloginDate), 'yyyy/MM/dd HH:mm:ss') : '';
	//	return ret;
	//};
	// 最終ログイン日時　改善
	const LastLoginCell = ({ row }) => {
		const getDisplayDate = (dateValue) => {
			if (dateValue === null) return '';
			
			const date = new Date(dateValue);
			if (!isNaN(date.getTime())) {
				return format(date, 'yyyy/MM/dd HH:mm:ss');
			}
			return dateValue;
		};
		
		return getDisplayDate(row.lastloginDate);
	};

	// const LastLoginCell = ({ row }) => {
	// 	// null、undefined、空文字列をチェック
	// 	if (!row.lastloginDate) {
	// 		return '';
	// 	}
		
	// 	// 日付オブジェクトを作成
	// 	const date = new Date(row.lastloginDate);
		
	// 	// 有効な日付かチェック
	// 	if (isNaN(date.getTime())) {
	// 		return '';
	// 	}
		
	// 	// 有効な日付の場合のみフォーマット
	// 	return format(date, 'yyyy/MM/dd HH:mm:ss');
	// };
	
	// 画面に表示するためのカラム設定						
	const columns = [
		{
			header: t('userNameJp'),
			accessor: 'userName',
			customCell: UserNameCell,
			sortFunction: compareStrings,
		},
		{
			header: t('userNameEn'),
			accessor: 'userEng',
			sortFunction: compareStrings,
		},
		{
			header: t('company'),
			accessor: 'org0Abbr',
			sortFunction: compareStrings,
		},
		{
			header: t('department'),
			accessor: 'org1Abbr',
			sortFunction: compareStrings,
		},
		{
			header: t('email'),
			accessor: 'email',
			sortFunction: compareStrings,
		},
		{
			header: t('authority'),
			accessor: 'usrroleDesc',
			sortFunction: compareStrings,
		},
		{
			header: t('dateExpiry'),
			accessor: 'expiryDate',
			customCell: ExpiryDateCell,
			sortFunction: compareStrings,
		},
		//最終ログイン日時　改善
		{
			header: t('lastloginDate'),
			accessor: 'lastloginDateSort',  // ソート用の文字列を使用
			customCell: LastLoginCell,       // 表示は元のまま
			sortFunction: compareStrings,    // 文字列比較を使用
		},
		{
			header: t('registrationDate'),
			accessor: 'recIdate',
			customCell: RecIDateCell,
			sortFunction: compareStrings,
		},
		{
			header: t('registeredUser'),
			accessor: 'creUser',
			sortFunction: compareStrings,
		},
		{
			header: t('lastUpdated'),
			accessor: 'recDate',
			customCell: RecDateCell,
			sortFunction: compareStrings,
		},
		{
			header: t('updateUser'),
			accessor: 'updUser',
			sortFunction: compareStrings,
		},
	];

	/**						
	 * ユーザー追加ボタン押下時の処理						
	 */
	const addUserClick = () => {
		// ユーザー追加画面へ遷移					
		navigate('/adduser');
	};

	/**						
	 * サービスの管理ボタン押下時の処理						
	 */
	const serviceManageClick = () => {
		// ユーザー追加画面へ遷移					
		navigate('/manageservice');
	};

	/**						
	 * ユーザーリスト取得APIの成功時の処理						
	 * @param {object} response ユーザーリスト取得APIのレスポンス						
	 */
	//function searchApiSuccess(response) {
	//	setUserManagementList(response);
	//};
	function searchApiSuccess(response) {
		const processedData = response.map(user => {
			const dateValue = user.lastloginDate;
			let sortValue = 0;
			let displayValue = dateValue;
			
			// null/空文字の場合
			if (!dateValue || dateValue === '') {
				sortValue = '0000000000000'; // 最小値（降順で最後）
			}
			// 文字列の場合（日付として解釈できるかチェック）
			else if (typeof dateValue === 'string') {
				const timestamp = new Date(dateValue).getTime();
				
				// 有効な日付に変換できた場合
				if (!isNaN(timestamp)) {
					sortValue = String(timestamp).padStart(13, '0');
				}
				// 日付として無効な文字列の場合（「初期設定未設定」など）
				else {
					sortValue = '0001000000000'; // 日付、初期設定未設定、空文字(null)の順でソートされるように設定
				}
			}
			// その他の型（数値など）の場合
			else {
				const timestamp = new Date(dateValue).getTime();
				sortValue = isNaN(timestamp) ? '0000000000000' : String(timestamp).padStart(13, '0');
			}
			
			return {
				...user,
				lastloginDateSort: sortValue,
				lastloginDate: displayValue
			};
		});
		
		setUserManagementList(processedData);
	}
	
	/**						
	 * ユーザーリスト取得APIの失敗時の処理						
	 * @param {object} error エラーオブジェクト						
	 */
	function searchApiError(error) {
		const detailErrorMessage = 'ユーザーリスト取得処理でエラーが発生しました。\n(An error occurred during the user list acquisition process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン					
		redirectToLogin();
	};

	/**						
	 * 共通エラー処理						
	 * @param {object} error エラーオブジェクト						
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ						
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	/**						
	 * ユーザー名のリンク押下時の処理						
	 * @param {object} row 選択している行の情報						
	 */
	const handleLinkClick = (row) => {
		const param = {
			userid: row.userid,
			dspUsrCode: row.dspUsrCode,
			userName: row.userName,
			userEng: row.userEng,
			org0Abbr: row.org0Abbr,
			org1Abbr: row.org1Abbr,
			email: row.email,
			usrroleDesc: row.usrroleDesc,
			expiryDate: row.expiryDate,
		};
		// ユーザー登録内容変更へ遷移
		navigate('/updateuser', { state: param })
	};

	/**
	 * クリア処理
	 */
	const clear = () => {
		setAddUserLinkAuthList(false);
		setAddUserBtnAuthFlg(false);
		setUserManagementList([]);
	}

	/**
 * 機能権限情報取得APIの成功時の処理
 */
	function funcroleApiSuccess(response) {
		localStorage.setItem('funcroleList', JSON.stringify(response));
	};

	/**
	 * 機能権限情報取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function funcroleApiError(error) {
		const detailErrorMessage = '機能権限情報取得処理でエラーが発生しました。\n(An error occurred during the function authority information acquisition process.)';
		commonError(error, detailErrorMessage);
		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * 権限情報取得APIの成功時の処理
	 * @param {array} response 権限情報取得APIのレスポンス
	 */
	function roleListApiSuccess(response) {
		// 権限一覧をセット										
		setUserRoleList(response);
	};

	/**
	 * 権限情報取得APIの失敗時の処理											
	 * @param {object} error エラーオブジェクト
	 */
	function roleListApiError(error) {
		const detailErrorMessage = '権限情報取得処理でエラーが発生しました。\n(An error occurred during the getrolelist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	// すべての処理が終了後に呼び出される処理
	useEffect(() => {
		(async () => {
			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}
			
			// ユーザー一覧項目取得API
			const url = setURL(API_URL.USER_MANAGEMENT);
			const getApiParam = {
				url: url,
				sysRole: SYS_ROLE.USER_MANAGEMENT,
				success: searchApiSuccess,
				error: searchApiError,
				json: userManagementData
			}
			await getApi(getApiParam);
			
			// 機能権限情報取得API
			const urlFuncrole = setURL(API_URL.FUNCROLE);
			const getFuncroleApiParam = {
				url: urlFuncrole,
				sysRole: SYS_ROLE.PORTAL,
				success: funcroleApiSuccess,
				error: funcroleApiError,
				json: funcroleData,
			}
			await getApi(getFuncroleApiParam);

			// 権限一覧取得取得API
			const urlUsrroleList = setURL(API_URL.SELECT_ITEM_USER_ROLE_LIST) + '?';
			// クエリパラメータ作成
			const params = {};
			params['showAdmin'] = true;
			const urlSearchParam =  String(new URLSearchParams(params));
			const getUsrroleListApiParam = {
				url: urlUsrroleList + urlSearchParam,
				sysRole: SYS_ROLE.USER_MANAGEMENT,
				success: roleListApiSuccess,
				error: roleListApiError,
				json: selectItemUserRoleList
			}
			await getApi(getUsrroleListApiParam);

			// ユーザー追加ボタンの権限フラグを設定
			const addUserBtnAuthFlg = getFuncroleFlg(SYS_ROLE.USER_MANAGEMENT, OBJ_ROLE.ADD_USER_BTN)
			setAddUserBtnAuthFlg(addUserBtnAuthFlg);

			// ユーザー登録内容変更リンクの権限フラグを設定
			const addUserLinkAuthList = getFuncroleFlg(SYS_ROLE.USER_MANAGEMENT, OBJ_ROLE.USER_UPDATE_LINK);
			setAddUserLinkAuthList(addUserLinkAuthList)

			setIsLoading(false);
		})();
	}, []);

	// 検索ボタンのクリックハンドラ
	const handleSearch = () => {
		// すべての検索条件が空かどうかチェック
		const isAllEmpty = 
		searchUserName.trim() === '' && 
		searchOrg.trim() === '' && 
		searchDept.trim() === '' && 
		searchMail.trim() === '' && 
		searchAuth.trim() === '';

		// すべて空なら全件表示（検索フラグをfalseに）
		if (isAllEmpty) {
			setIsSearched(false);
			setFilteredUsers([]);
			return;
		}

		// 検索条件がある場合は各フィールドに対して部分一致でフィルタリングを実行
		const filtered = userManagementList.filter(user => {
			/// 氏名、企業名、所属名、メールアドレスは部分一致で検索
			const nameMatch = searchUserName.trim() === '' || 
				(user.userName && user.userName.toLowerCase().includes(searchUserName.toLowerCase()));
			
			const orgMatch = searchOrg.trim() === '' || 
				(user.org0Abbr && user.org0Abbr.toLowerCase().includes(searchOrg.toLowerCase()));
			
			const deptMatch = searchDept.trim() === '' || 
				(user.org1Abbr && user.org1Abbr.toLowerCase().includes(searchDept.toLowerCase()));
			
			const mailMatch = searchMail.trim() === '' || 
				(user.email && user.email.toLowerCase().includes(searchMail.toLowerCase()));
			
			// 権限は完全一致で検索
			const authMatch = searchAuth.trim() === '' || 
				((user.authority || user.usrroleDesc || '') + '') === searchAuth;
			
			// すべての条件に一致する場合のみtrueを返す（AND条件）
			return nameMatch && orgMatch && deptMatch && mailMatch && authMatch;
		});
		setFilteredUsers(filtered);
		setIsSearched(true);
	};	
	
	// クリアボタンのクリックハンドラ
	const handleClearSearch = () => {
		// すべての検索条件をクリア
		setSearchUserName('');
		setSearchOrg('');
		setSearchDept('');
		setSearchMail('');
		setSearchAuth('');
		// 検索状態をリセット（全件表示に戻す）
		setIsSearched(false);
		setFilteredUsers([]);
	}

	// テーブルに表示するデータ
	const displayData = isSearched ? filteredUsers : userManagementList;

	if (isLoading) {
		// ロード中の場合はローディング画面					
		return (
			<Loading />
		);
	} else {
		return (
			<div className="userManagement">
				{/* 検索追加 */}
				<div className="search-section">
					<div className="search-container">
						<label htmlFor="searchUserName">{t('氏名（漢字）')}</label>
						<input
							id="searchUserName"
							type="text"
							value={searchUserName}
							onChange={(e) => setSearchUserName(e.target.value)}
							className="search-input"
						/>
					</div>
					<div className="search-container">
						<label htmlFor="searchOrg">{t('企業名')}</label>
						<input
							id="searchOrg"
							type="text"
							value={searchOrg}
							onChange={(e) => setSearchOrg(e.target.value)}
							className="search-input"
						/>
					</div>
					<div className="search-container">
						<label htmlFor="searchDept">{t('所属名')}</label>
						<input
							id="searchDept"
							type="text"
							value={searchDept}
							onChange={(e) => setSearchDept(e.target.value)}
							className="search-input"
						/>
					</div>
					<div className="search-container">
						<label htmlFor="searchMail">{t('メールアドレス')}</label> 
						<input
							type="text"
							value={searchMail}
							onChange={(e) => setSearchMail(e.target.value)}
							className="search-input"
						/>
					</div>
					<div className="search-container">
					<label htmlFor="searchAuth">{t('権限')}</label>
					<select
						id="searchAuth"
						value={searchAuth}
						onChange={(e) => setSearchAuth(e.target.value)}
						className="search-input"
					>
						<option value="">{t('すべて')}</option>
						{/* userRoleListから取得した権限リストを表示 */}
						{userRoleList && userRoleList.map((role) => (
						<option key={role.id} value={role.usrroleDesc}>
							{role.usrroleDesc}
						</option>
						))}
					</select>
					</div>
					<div className="search-button-container">
						{/* 検索ボタン */}
						<Button
							variant="primary"
							size="small"
							onClick={handleSearch}
							className="search-button"
						>
							<Search /> {t('検索')}
						</Button>
						{/* クリアボタン */}
						<Button
							variant="secondary"
							size="small"
							onClick={handleClearSearch}
							className="clear-button"
						>
							条件クリア
						</Button>
					</div>
				</div>
				<div className="buttons">
					<Button
						variant="primary"
						size="small"
						className="addUserBtn"
						status="success"
						onClick={addUserClick}
						disabled={!addUserBtnAuthFlg}
					>
						<Plus />{t('adduser')}
					</Button>
					<Button
						variant="primary"
						size="small"
						className="manageServiceBtn"
						status="success"
						onClick={serviceManageClick}
						disabled={!addUserBtnAuthFlg}
					>
						{t('manageService')}
					</Button>
				</div>
				<div className='table-wrap'>
					<Table
						className="userList"
						columns={columns}
						rowId="id"
						rows={displayData}
						rowsPerPageOptions={[10, 50, 100, 'All']}
						rowProps={{ hover: false }}
						tablePaginationProps={{
							labelDisplayedRows: ({ from, to, count }) => `全${count}件`,
							truncate: true,
						}}
						emptyProps={{ text: t('message.1000100') }}
					/>
				</div>
			</div>
		);
	}
}

export default UserManagement;							
